import React, { useState } from "react";
import AddProject1 from "./addProject1";
import ProjectList from "./projectlist";
import AOS from "aos";
import "aos/dist/aos.css";
import { Plus, X } from "lucide-react";

AOS.init();

const Addproject = () => {
  const [showAddProjectForm, setShowAddProjectForm] = useState(false);
  const [editingProject, setEditingProject] = useState(null);

  const handleAddProjectClick = () => {
    setShowAddProjectForm(true);
    setEditingProject(null);
  };

  const handleEditProject = (project) => {
    setEditingProject(project);
    setShowAddProjectForm(true);
  };

  const handleCloseForm = () => {
    setShowAddProjectForm(false);
    setEditingProject(null);
  };
  const [reload, setReload] = useState(false);
  function handleReloadPrjects() {
    setReload(true)
    setTimeout(() => {
      setReload(false)
    }, 2000)
  }

  return (
    <>

      <div className="container-fluid gap-5 bg-gray-900"
        style={{
          overflow: 'auto',
          height: '100vh',
          width: '100%',
          scrollbarWidth: '1px',
          msOverflowStyle: 'none'
        }}>

        <div className="relative p-6 ">
          {/* Heading */}
          <h1 className="text-3xl font-bold text-white mb-6" data-aos="fade-up" >Project List</h1>

          {/* Add Project Button */}
          {/* <button
        onClick={handleAddProjectClick}
        className="fixed top-4 right-4 bg-blue-500 text-white p-2 rounded-full shadow-lg hover:bg-blue-600 transition-all z-50"
         data-aos="fade-up"  
        >
        <Plus className="w-6 h-6" />
      </button> */}
          {/* Add Project Button */}
          <button
            onClick={handleAddProjectClick}
            className="fixed top-4 right-4 bg-blue-500 text-white p-2 rounded-full shadow-lg hover:bg-blue-600 transition-all z-50 group overflow-hidden"
            data-aos="fade-up"
            
          >
            <div className="flex items-center">
              <span className="text-sm font-medium opacity-0 max-w-0 group-hover:opacity-100 group-hover:max-w-xs group-hover:mr-2 transition-all duration-300 whitespace-nowrap">
                Add Project
              </span>
              <Plus className="w-6 h-6 group-hover:rotate-90 transition-transform duration-300" />
            </div>
          </button>

          {/* Project List */}
          <ProjectList onEditProject={handleEditProject} reload={reload} />

          {/* Add Project Form Modal */}
          {showAddProjectForm && (
            <div
              className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50"
              onClick={handleCloseForm}
            >
              <div
                className=" rounded-lg p-8 w-11/12 max-w-3xl "
                onClick={(e) => e.stopPropagation()}
                data-aos="fade-left"
              >
                {/* <button
              onClick={handleCloseForm}
              className="absolute top-2 right-2 p-1 hover:bg-gray-100 rounded-full"
              >
              <X className="w-6 h-6" />
            </button> */}
                <AddProject1
                  editingProject={editingProject}
                  onClose={handleCloseForm}
                  handleReloadPrjects={handleReloadPrjects}
                />
              </div>
            </div>
          )}
        </div>
      </div>
    </>
  );
};

export default Addproject;